import { SDS_SPACE_XXSMALL, SDS_SPACE_SMALL, SDS_SPACE_XSMALL, SDS_SPACE_MEDIUM, SDS_SPACE_LARGE, SDS_SPACE_XLARGE, SDS_SPACE_XXLARGE } from '@s-group/design-system-tokens/web/tokens/space.es6.js';
import { css } from 'styled-components';

const direction = {
    vertical: 'column',
    horizontal: 'row',
};
const gap = {
    // sizing: [row, column]
    xsmall: [SDS_SPACE_XXSMALL, SDS_SPACE_SMALL],
    small: [SDS_SPACE_XSMALL, SDS_SPACE_MEDIUM],
    medium: [SDS_SPACE_SMALL, SDS_SPACE_LARGE],
    large: [SDS_SPACE_MEDIUM, SDS_SPACE_XLARGE],
    xlarge: [SDS_SPACE_LARGE, SDS_SPACE_XXLARGE],
};
const CheckboxGroupStyle = css `
    border: 0;
    display: flex;
    flex-flow: ${({ orientation }) => orientation && direction[orientation]}
        wrap;
    gap: ${({ sizing }) => sizing && gap[sizing].join(' ')};
    margin: 0;
    padding: 0;
`;

export { CheckboxGroupStyle };
//# sourceMappingURL=CheckboxGroup.styles.js.map
